'use strict';
var readLdJSON;

readLdJSON = function(domID) {
  var el, error, text;
  el = document.getElementById(domID);
  if (!el) {
    return {};
  }
  text = el.textContent.trim();
  try {
    return JSON.parse(text);
  } catch (error1) {
    error = error1;
    error.message += 'Attempted to parse:' + text;
    throw error;
  }
};

module.exports = {
  readLdJSON: readLdJSON
};

